module.exports = __webpack_public_path__ + "static/media/lob-member-2.f2c93624.jpg";